function useEmployeeSalaryAbsenceDeduct() {
  return {};
}

export default useEmployeeSalaryAbsenceDeduct;
